import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { ProcessingRequest } from "../../http/processingRequest/types";
import useProcessingRequestLabelsPackagingsApi from "../../http/processingRequestLabelsPackagings/api";
import { formatPrice, getHourlyCostFromMinutes } from "../../utils";
import Table from "../ui/Table";

type RequestRecapProps = {
  request: ProcessingRequest;
  totalUsedProductsCost: number;
};

const RequestRecap: FC<RequestRecapProps> = ({ request, totalUsedProductsCost }) => {
  const i18n = useI18n();

  if (!request) {
    return null;
  }

  const requestLabelsPackagingsApi = useProcessingRequestLabelsPackagingsApi();

  const result = requestLabelsPackagingsApi.useProcessingRequestLabelsPackagings(request.id.toString());
  const [labelsAndPackagings, error] = [result.data, result.error];

  const totalLabelsAndPackagingst =
    labelsAndPackagings?.items.reduce((sum, entry) => sum + (entry.unitCost ?? 0) * (entry.expectedQuantity ?? 0), 0) ??
    0;

  const workingMinutesCost = request.expectedMinutes
    ? getHourlyCostFromMinutes(request.expectedMinutes, request.costPerHour)
    : 0;

  const totalCost = totalLabelsAndPackagingst + workingMinutesCost + totalUsedProductsCost;

  return (
    <Table
      renderRow={(item) => (
        <>
          <td align="left">{item.key}</td>
          <td align="right">{formatPrice(item.value, i18n.language)}</td>
        </>
      )}
      head={
        <tr>
          <th></th>
          <th align="right">{i18n.t.common.totalCost}:</th>
        </tr>
      }
      footer={
        <tr>
          <td>{i18n.t.common.totalCost}:</td>
          <td align="right">{formatPrice(totalCost, i18n.language)}</td>
        </tr>
      }
      items={[
        {
          key: i18n.t.common.usedProducts,
          value: totalUsedProductsCost,
        },
        {
          key: `${i18n.t.packagings.plural} & ${i18n.t.labels.plural}`,
          value: totalLabelsAndPackagingst,
        },
        {
          key: i18n.t.common.workingMinutes,
          value: workingMinutesCost,
        },
      ]}
      error={error}
    ></Table>
  );
};

export default RequestRecap;
